// extracted by mini-css-extract-plugin
export var memorable = "Memorable-module--memorable--2RF9C";
export var outer = "Memorable-module--outer--2bajx";
export var animatedbutton = "Memorable-module--animatedbutton--1Dh_c";
export var press = "Memorable-module--press--3yuNW";
export var spinner = "Memorable-module--spinner--3Icv2";
export var spin = "Memorable-module--spin--bAu47";
export var payment = "Memorable-module--payment--1ZdqL";
export var complete = "Memorable-module--complete--2p9Ti";
export var confetti = "Memorable-module--confetti--3AoOZ";